import React from 'react'
import { Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'

const sourceCellWrapperCss = css`
  min-height: 150px;
`

export default function SourceCellSkeleton(): JSX.Element {
  return (
    <div css={sourceCellWrapperCss} aria-hidden>
      <Skeleton.Paragraph maxWidth="90%" />
      <Skeleton.Paragraph maxWidth="75%" />
      <Skeleton.Paragraph maxWidth="80%" />
    </div>
  )
}
